import { render } from "./PageHeader.vue?vue&type=template&id=50da8477&scoped=true"
const script = {}

import "./PageHeader.vue?vue&type=style&index=0&id=50da8477&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50da8477"

export default script